"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _Slide = _interopRequireDefault(require("@mui/material/Slide"));
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));
var _system = require("@mui/system");
var _Button = _interopRequireDefault(require("../Button"));
var _Text = _interopRequireDefault(require("../Text"));
var _theme = require("../../theme");
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * @param props
 * @returns {*}
 * @constructor
 */
var Transition = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_Slide["default"], (0, _extends2["default"])({
    direction: "up"
  }, props));
});

/**
 * 
 * @param {*} param0 
 * @returns 
 */
var StepCompletionNotif = function StepCompletionNotif(_ref) {
  var dialog = _ref.dialog,
    open = _ref.open,
    type = _ref.type,
    title = _ref.title,
    maxWidth = _ref.maxWidth,
    fullWidth = _ref.fullWidth,
    handleClose = _ref.handleClose,
    handleNext = _ref.handleNext,
    testid = _ref.testid;
  var ModalStyled = (0, _system.styled)('div')({
    overflow: 'auto',
    outline: 'none',
    padding: '40px',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    backgroundColor: _theme.colors.surface,
    height: '100%',
    maxWidth: fullWidth ? null : '500px'
  });
  var TitleIconWrapper = (0, _system.styled)('div')({
    width: '100%',
    paddingBottom: '15px',
    color: _theme.colors.mainTextGrey,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  });
  var StyledDialog = (0, _system.styled)(_Dialog["default"])({
    '& .MuiDialog-paper': {
      borderRadius: 8
    },
    '& .paperWidthSm': {
      maxWidth: '500px'
    }
  });
  var formStyle = {
    flex: 1,
    paddingBottom: '0',
    paddingTop: '0',
    width: 'auto'
  };
  return /*#__PURE__*/_react["default"].createElement(StyledDialog, {
    maxWidth: maxWidth || 'md',
    fullWidth: fullWidth,
    onClose: handleClose,
    open: open,
    "aria-labelledby": title,
    TransitionComponent: Transition,
    keepMounted: true
    // disableBackdropClick={true}
    ,
    disableEscapeKeyDown: true
  }, /*#__PURE__*/_react["default"].createElement(ModalStyled, null, /*#__PURE__*/_react["default"].createElement(TitleIconWrapper, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    testid: testid,
    align: "center",
    bold: true,
    mediumLarge: true,
    display: "inline-block",
    margin: "0"
  }, _i18n["default"].t(_tokens["default"].labels.completed, {
    step: type
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    style: formStyle
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true
  }, dialog), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    onClick: handleNext,
    marginTop: 2.5
  }, _i18n["default"].t(_tokens["default"].buttons.next))))));
};
var _default = exports["default"] = StepCompletionNotif;